var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57.294 57.294",
    xmlSpace: "preserve",
    fill: "#121212",
    stroke: "#121212",
    strokeWidth: 0.00057294,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212"
    },
    d: "M35.147,7.002c0,1.181,0.524,2.379,1.34,3.112c0.941-0.163,1.66-1.82,1.66-1.82h2 c0,1-0.524,2.087-1.34,2.819c0.114,0.01,0.224-0.039,0.34-0.039c2.206,0,4-1.83,4-4.037s-1.794-4.018-4-4.018 C36.941,3.02,35.147,4.795,35.147,7.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212"
    },
    d: "M4.147,19.002c0,2.206,1.794,4,4,4c0.116,0,0.226,0.122,0.34,0.112 c-0.816-0.733-1.34-1.82-1.34-2.82h2c0,0,0.719,1.657,1.66,1.819c0.816-0.733,1.34-1.858,1.34-3.039c0-2.206-1.794-4.037-4-4.037 C5.941,15.038,4.147,16.795,4.147,19.002z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#121212"
    },
    points: "51.147,3.614 52.985,3.001 51.147,2.389 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#121212"
    },
    points: "40.67,16.002 39.624,16.002 40.147,17.309 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212"
    },
    d: "M18.147,38.294h-5c-0.553,0-1-0.74-1-1.292v-5c0-0.29,0.126-0.565,0.345-0.756 c0.219-0.189,0.51-0.277,0.797-0.234l6.69,0.956l6.708-3.353l-0.303-0.455l-0.607-0.91l-6.235,2.672 c-0.224,0.096-0.478,0.255-0.71,0.176l-5.847-1.804h-2.838v7h-2v-7h-3c-1.654,0-3,1.053-3,2.708v10.292h2v-9h2v23h3V42.002 c0-0.553,0.447-0.708,1-0.708h7c0.553,0,1,0.155,1,0.708v7.292h3v-8.292C21.147,39.347,19.801,38.294,18.147,38.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    style: {
      fill: "#121212"
    },
    d: "M51.147,15.002c0,0.552-0.447,1.292-1,1.292h-7.323l-1.748,4.225 c-0.152,0.38-0.519,0.556-0.929,0.556c-0.409,0-0.776-0.139-0.929-0.519l-1.748-4.262h-1.961l-5.562,4.489l-2.646,5.22l0.846,1.232 l3.168-4.77c0.062-0.095,0.142-0.187,0.232-0.254l4-3.005c0.302-0.227,0.709-0.265,1.047-0.097c0.339,0.17,0.553,0.514,0.553,0.893 v23.292h3v-5.292v-8c0-0.553,0.447-0.708,1-0.708h7c0.553,0,1,0.155,1,0.708v7.292h3v-8.292c0-1.655-1.346-2.708-3-2.708h-5 c-0.553,0-1-0.74-1-1.292v-6c0-0.553,0.447-0.708,1-0.708h6c1.654,0,3-1.638,3-3.292v-4.708h-2V15.002L51.147,15.002z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.147,13.002c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S35.838,13.002,39.147,13.002z M39.147,3.001 c2.206,0,4,1.794,4,4s-1.794,4-4,4c-0.117,0-0.226,0.122-0.34,0.112c0.816-0.732,1.34-1.819,1.34-2.819h-2 c0,0-0.719,1.657-1.66,1.819c-0.816-0.732-1.34-1.857-1.34-3.038C35.147,4.869,36.941,3.001,39.147,3.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.147,25.002c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S4.838,25.002,8.147,25.002z M8.147,15.002 c2.206,0,4,1.794,4,4c0,1.181-0.524,2.379-1.34,3.112c-0.941-0.163-1.66-1.82-1.66-1.82h-2c0,1,0.524,2.087,1.34,2.819 c-0.114,0.01-0.224-0.039-0.34-0.039c-2.206,0-4-1.83-4-4.037S5.941,15.002,8.147,15.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.463,2.053l-6-2c-0.307-0.105-0.64-0.052-0.901,0.137s-0.415,0.49-0.415,0.811v8v5.293h-14 c-0.234,0-0.461-0.064-0.641,0.085l-6,4.927c-0.105,0.089-0.192,0.162-0.254,0.285l-2.836,5.655l-6.314,2.696l-5.639-1.737 c-0.102-0.035-0.209,0.089-0.316,0.089h-8c-2.757,0-5,1.951-5,4.708v11c0,0.552,0.447,1.292,1,1.292h3v12h-4v2h5h5h4 c0.553,0,1-0.74,1-1.292v-4.708h2h5h7c0.553,0,1-0.74,1-1.292v-4.708h6h5c0.553,0,1-0.74,1-1.292v-4.708h6h5h3v-2h-2v-8.292 c0-2.757-2.243-4.708-5-4.708h-4v-4h5c2.757,0,5-2.536,5-5.292v-6c0-0.553-0.447-0.708-1-0.708h-3V5.722l5.316-1.772 c0.409-0.136,0.684-0.518,0.684-0.949S56.872,2.189,56.463,2.053z M40.67,16.002l-0.523,1.307l-0.523-1.308h1.046L40.67,16.002 L40.67,16.002z M14.147,49.294c-0.553,0-1,0.155-1,0.708v5.292h-2v-12h5v6H14.147z M18.147,49.294v-7.292 c0-0.553-0.447-0.708-1-0.708h-7c-0.553,0-1,0.155-1,0.708v13.292h-3v-23h-2v9h-2V31.002c0-1.655,1.346-2.708,3-2.708h3v7h2v-7 h2.838l5.846,1.802c0.232,0.079,0.486-0.007,0.71-0.102l6.235-2.708l0.607,0.892l0.303,0.446l-6.708,3.349l-6.69-0.958 c-0.287-0.043-0.578,0.044-0.797,0.233c-0.218,0.189-0.344,0.463-0.344,0.754v5c0,0.552,0.447,1.292,1,1.292h5 c1.654,0,3,1.053,3,2.708v8.292H18.147z M29.147,43.294c-0.553,0-1,0.155-1,0.708v5.292h-5v-8.292c0-2.757-2.243-4.708-5-4.708h-4 v-3.139l5.858,0.837c0.202,0.028,0.406-0.006,0.589-0.096l8-4c0.146-0.073,0.261-0.184,0.354-0.313 c0.008-0.011,0.023-0.015,0.031-0.026l3.905-5.857l2.263-1.698v21.292H29.147z M47.147,37.294h-5v-6h5V37.294z M53.147,15.002 c0,1.654-1.346,3.292-3,3.292h-6c-0.553,0-1,0.155-1,0.708v6c0,0.552,0.447,1.292,1,1.292h5c1.654,0,3,1.053,3,2.708v8.292h-3 v-7.292c0-0.553-0.447-0.708-1-0.708h-7c-0.553,0-1,0.155-1,0.708v8v5.292h-3V20.002c0-0.379-0.214-0.725-0.553-0.895 c-0.338-0.168-0.745-0.133-1.047,0.095l-4,3c-0.091,0.067-0.17,0.15-0.232,0.245l-3.168,4.752l-0.846-1.27l2.646-5.147 l5.562-4.488h1.961l1.748,4.225c0.152,0.38,0.52,0.556,0.929,0.556s0.776-0.139,0.929-0.519l1.748-4.262h7.323 c0.553,0,1-0.74,1-1.292v-4.708h2C53.147,10.294,53.147,15.002,53.147,15.002z M51.147,3.614V2.389l1.838,0.612L51.147,3.614z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.147,
    y: 5.001,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.147,
    y: 5.001,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.147,
    y: 5.001,
    width: 2,
    height: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.2f1664ff9d6f9e80b1b23d4c9c483072.svg";
export { ForwardRef as ReactComponent };